// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import UpSquareTwoToneSvg from "@fishx/icons-svg/es/asn/UpSquareTwoTone";
import FishxIcon from '../components/FishxIcon';

var UpSquareTwoTone = function UpSquareTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: UpSquareTwoToneSvg
  }));
};

UpSquareTwoTone.displayName = 'UpSquareTwoTone';
export default React.forwardRef(UpSquareTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/UpSquareTwoTone.js
// module id = 4332
// module chunks = 0